import { render, staticRenderFns } from "./CampaignReport.vue?vue&type=template&id=15e2dc4a&scoped=true&"
import script from "./CampaignReport.vue?vue&type=script&lang=ts&"
export * from "./CampaignReport.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignReport.vue?vue&type=style&index=0&id=15e2dc4a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2dc4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
